module.exports = __webpack_public_path__ + "img/upload_video.b884fdae.svg";